module.exports = __webpack_public_path__ + "static/media/x.14002837.svg";